module.exports = __webpack_public_path__ + "static/media/ig.03ac64ba.png";